import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { IconButton, Tooltip } from '@mui/material';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import PageHeaderDialogs from '../../../../enums/PageHeaderDialogs';

interface Props {
    onOpenDialogHandler: (event: React.MouseEvent<HTMLElement>) => void;
}

export default function HeaderActionsCreateContact({ onOpenDialogHandler }: Props) {
    const { classes } = useStyles();

    return (
        <Tooltip title="Create Contact">
            <IconButton
                data-name={PageHeaderDialogs.createContact}
                onClick={onOpenDialogHandler}
                className={classes.iconButton}
                size="large"
            >
                <PersonAddIcon />
            </IconButton>
        </Tooltip>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    iconButton: {
        padding: theme.spacing(1),
        '& .MuiSvgIcon-root': {
            fill: theme.palette.appHeader.contrastText,
        },
    },
}));
